import axios from 'axios'
import store from '@/store'

const urlPath = '/dps/parking'

export default {
  async summary(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/summary`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback(error)
    }
  },
  async status(params, callback, errorCallback) {
    let apiUrl = store.state.apiSelected.apiHost
    try {
      let resp = await axios.get(`${apiUrl}${urlPath}/status`, {
        params: params
      })
      callback(resp.data)
    } catch (error) {
      console.log(error)
      errorCallback()
    }
  }
}



// WEBPACK FOOTER //
// ./src/services/parkingService.js